import React from "react";
import ReactDOMClient from "react-dom/client";
import singleSpaReact from "single-spa-react";
import { CpButton, CpHeader } from "canopy-styleguide!sofe";
import { useWithUserAndTenant } from "cp-client-auth!sofe";

const RootComponent = () => {
  const onLogout = () => (window.location.href = "#/logout");
  const [user, tenant] = useWithUserAndTenant();
  const isClientPortal = user?.role === "Client";

  if (tenant.crm_status === "crm_hierarchy_complete") {
    window.location.href = "/";
  }

  return (
    <div className="flex flex-col" style={{ height: "100vh" }}>
      <header>
        <CpHeader className="cp-subheader-sm cp-wt-semibold">
          {isClientPortal
            ? tenant?.company_name || "Client Portal"
            : "Client and Contact Restructure"}
        </CpHeader>
      </header>
      <main
        className="flex flex-col items-center justify-center grow"
        style={{ marginBottom: "54px" }}
      >
        <div className="cp-wt-semibold">
          {isClientPortal ? "Maintenance Alert" : "Finalizing Migration"}
        </div>
        <div className="cp-color-app-secondary-text">
          {isClientPortal
            ? "Your client portal is currently undergoing some maintenance and is unavailable. Please try again later."
            : "You have started your organization's migration onto the new client and contact structure. This may take several hours."}
        </div>
        <CpButton btnType="primary" className="cp-mt-24" onClick={onLogout}>
          Log out
        </CpButton>
      </main>
    </div>
  );
};

const reactLifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: RootComponent,
  errorBoundary() {
    return <div>An error has occured</div>;
  },
});
export const bootstrap = reactLifecycles.bootstrap;
export const mount = reactLifecycles.mount;
export const unmount = reactLifecycles.unmount;